export class ProfileModalTypes {
  static BASICS = 'Profile Basics';

  static ADDRESS = 'Home Address';

  static PHARMACY = 'Preferred Pharmacy';

  static PHOTO = 'Profile Photo';
}
